import { BIModel } from './BIModel';

export class MKTShareClosetBIModel extends BIModel {

  static eventName = 'MKT_share_closet';

  #flow;
  #closetOwnerId;
  #channel;

  constructor(userId, flow, closetOwnerId, channel) {
    super(MKTShareClosetBIModel.eventName, userId);
    this.#flow = flow;
    this.#closetOwnerId = closetOwnerId;
    this.#channel = channel;
  }

  get flow() {
    return this.#flow;
  }

  get closetOwnerId() {
    return this.#closetOwnerId;
  }

  get channel() {
    return this.#channel;
  }

  get modelData() {
    return {
      flow: this.flow,
      closet_owner_id: this.closetOwnerId,
      channel: this.channel,
    };
  }

}